// Import model
import { FilterLeadTypeRequest } from '../models/FilterLeadTypeRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { LeadTypeCondition } from '../models/LeadTypeCondition';
import { LeadTypeFields } from '../models/LeadTypeFields';
import { LeadTypeIndexedFields } from '../models/LeadTypeIndexedFields';

// Import dependency serializers (for complex types)
import { LeadTypeConditionSerializer } from './LeadTypeConditionSerializer';
import { LeadTypeFieldsSerializer } from './LeadTypeFieldsSerializer';
import { LeadTypeIndexedFieldsSerializer } from './LeadTypeIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterLeadTypeRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterLeadTypeRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterLeadTypeRequest instance
   */
  static deserialize(json: string): FilterLeadTypeRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterLeadTypeRequest instance
   */
  static fromObject(obj: any): FilterLeadTypeRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterLeadTypeRequest');
    }


    const instance: FilterLeadTypeRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as LeadTypeIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as LeadTypeFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        LeadTypeConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterLeadTypeRequest instances
   */
  static deserializeArray(json: string): FilterLeadTypeRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterLeadTypeRequest instance to a JSON string
   */
  static serialize(instance: FilterLeadTypeRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterLeadTypeRequest instance to a plain object
   */
  static toObject(instance: FilterLeadTypeRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        LeadTypeConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterLeadTypeRequest instances to a JSON string
   */
  static serializeArray(instances: FilterLeadTypeRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
